import { isRecord } from 'lib/object/objectUtils'
import getLoyaltyAccountClosedErrorCode from './getLoyaltyAccountClosedErrorCode'

const LOYALTY_TIERS: ReadonlyArray<App.LoyaltyTier> = ['bronze', 'silver', 'gold', 'platinum', 'infinite']

function isLoyaltyTier(value: unknown): value is App.LoyaltyTier {
  return LOYALTY_TIERS.some(tier => tier === value)
}

/**
 * The tier of a Société account closed by an admin, which it keeps if it's reopened.
 *
 * svc-lux-loyalty refuses the read with 409 `ACCOUNT_CLOSED` but still sends the account summary
 * under `result.accountSummary`. The other closed codes carry no summary, so there's no tier.
 */
function getLoyaltyClosedAccountTier(error: unknown): App.LoyaltyTier | undefined {
  if (getLoyaltyAccountClosedErrorCode(error) !== 'ACCOUNT_CLOSED') {
    return undefined
  }
  if (!isRecord(error) || !isRecord(error.result) || !isRecord(error.result.accountSummary)) {
    return undefined
  }
  const { tier } = error.result.accountSummary
  return isLoyaltyTier(tier) ? tier : undefined
}

export default getLoyaltyClosedAccountTier
